import clsx from "clsx";
import { FC } from "react";

import { IEditorListProps } from "./dashboard-card-editor.models";
import { EditorListStyled } from "./dashboard-card-editor.styled";

export const EditorList: FC<IEditorListProps> = ({
  label,
  options,
  selected,
  onSelect,
}) => (
  <EditorListStyled>
    <div className="list-label">{label}</div>
    <div className="list-header">
      {options.find(option => option.value === selected)?.label || "—"}
    </div>
    <div className="list-scroll">
      {options.map(option => (
        <button
          key={option.value}
          type="button"
          className={clsx("list-item", { selected: option.value === selected })}
          onClick={() => onSelect(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  </EditorListStyled>
);
